module.exports = __webpack_public_path__ + "media/veracruz/gob_veracruz-90bbeff6.png";